import { Zap } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-violet-500/15 py-8 sm:py-10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <span className="text-sm font-semibold bg-gradient-to-r from-white to-violet-300/80 bg-clip-text text-transparent">
          ReachMeNow
        </span>
        <p className="text-xs text-violet-200/35">
          &copy; {new Date().getFullYear()} ReachMeNow. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
